import React, { useEffect, useState } from 'react'

import { benefitPlanPeriods, getRenewalPlanPeriod } from 'core'
import { TaskStatus } from 'core/application/adminDashboard/adminTasks'
import { PlanPeriodDto } from 'core/application/adminDashboard/benefitDetails/benefitPlanPeriods'
import {
  GetBenefitUsageDetailsRequestsResponse,
  getBenefitUsageDetails,
} from 'core/application/adminDashboard/reimbursements/perks/getBenefitUsageDetails'

import useAdminTasks from 'common/hooks/useAdminTasks'

import { Col, Row, Skeleton } from 'common/components'

import { BenefitPlanPeriodDropDown } from '../../../common/components'
import { useQueryRequestV2 } from '../../../common/hooks'
import WelcomeBox from '../common/welcomeBox'
import PerksAdminCountdownTimer from './adminCountdownTimer'
import PerksAdminTasks from './adminTasks'
import BenefitUsageStatistic from './benefitUsageStatistic'

const AdminDashboardHome: React.FC = () => {
  const [tasks] = useAdminTasks()
  const tasksCompleted = tasks && !tasks.some((x) => x.status != TaskStatus.Done)
  const [selectedPlanPeriod, setSelectedPlanPeriod] = useState<PlanPeriodDto | null>(null)

  const { data: planPeriods } = useQueryRequestV2<PlanPeriodDto[]>({
    initialState: null,
    queryFn: () => benefitPlanPeriods(),
  })

  const { data: renewalPlanPeriod } = useQueryRequestV2({
    initialState: undefined,
    queryFn: () => getRenewalPlanPeriod(),
  })

  useEffect(() => {
    if (planPeriods && planPeriods.length > 0) {
      const found = planPeriods.find((x) => x.active)

      if (found) {
        setSelectedPlanPeriod(found)
      }
    }
  }, [planPeriods])

  return (
    <>
      <Row justify="end" className={'w-100 font-16 text-light-bold mb-16'}>
        {planPeriods && planPeriods.length > 1 && (
          <>
            <BenefitPlanPeriodDropDown
              text={'Allowance Period'}
              planPeriods={planPeriods}
              showStartDateAndEndDate={true}
              onPlanPeriodSelected={(planPeriodId: string) => {
                const found = planPeriods.find((x) => x.id === planPeriodId)
                setSelectedPlanPeriod(found)
              }}
            />
          </>
        )}
      </Row>

      {tasks && (
        <>
          {!tasksCompleted && <PerksAdminTasks />}

          {tasksCompleted && renewalPlanPeriod && (
            <Row className={'mb-16'}>
              <Col span={24}>
                <PerksAdminCountdownTimer />
              </Col>
            </Row>
          )}

          {tasksCompleted && (
            <>
              {selectedPlanPeriod && (
                <>
                  <Row className={'mb-16'}>
                    <Col span={24} xl={18}>
                      <WelcomeBox planPeriodId={selectedPlanPeriod.id} />
                    </Col>
                  </Row>
                  <Row>{selectedPlanPeriod && <BenefitDetails planPeriod={selectedPlanPeriod} />}</Row>
                </>
              )}
            </>
          )}
        </>
      )}
    </>
  )
}

export default AdminDashboardHome

type BenefitDetailsProps = {
  planPeriod: PlanPeriodDto
}

const BenefitDetails = ({ planPeriod }: BenefitDetailsProps) => {
  const {
    data: stats,
    reload: reloadStats,
    isLoading: areStatsLoading,
  } = useQueryRequestV2<GetBenefitUsageDetailsRequestsResponse>({
    initialState: {
      totalUsage: {
        id: 0,
        categoryName: '',
        totalAllowance: 0,
        allowanceUsed: 0,

        percentageIncrease: 0,
        percentageUsed: 0,
        color: '',
      },
      categoryUsages: [],
    },
    queryFn: () => {
      return getBenefitUsageDetails(planPeriod.id)
    },
  })

  useEffect(() => {
    reloadStats()
  }, [planPeriod?.id])

  return (
    <Skeleton loading={areStatsLoading}>
      <Col span={24} xl={18}>
        {stats?.totalUsage && <BenefitUsageStatistic data={stats.totalUsage} />}
      </Col>
      {/* <Col span={24} xl={15}>
        {stats?.categoryUsages && <SpendingByCategoryStatistic data={stats.categoryUsages} />}
      </Col>*/}
    </Skeleton>
  )
}
